<template>
  <!-- 非身份用户，权利跳转 -->
  <van-popup v-model="showPopup" class="transparent-popup">
    <div class="v-pop-jump">
      <div class="content">
        <div class="btn-close" @click="close"></div>
        <div
          v-if="popJumpInfo.type == 'mgOffi' && popJumpInfo.isHit == 1"
          class="wrap-box"
        >
          <div class="tips">
            <div class="t1">嘘～你的权限不足！</div>
            <div class="t2">这是超级玩家专享特权，快去认证吧</div>
          </div>
          <div class="ft">
            <div class="confirm" @click="handleConfirm">去认证超级玩家</div>
          </div>
        </div>
        <div v-else-if="popJumpInfo.type == 'preTask'" class="wrap-box">
          <div class="tips">
            <div class="t1">抱歉哦～</div>
            <div class="t2">{{ popJumpInfo.text }}</div>
          </div>
          <div class="ft">
            <div class="confirm" @click="handleConfirm">
              {{ popJumpInfo.btnText }}
            </div>
          </div>
        </div>
        <div v-else class="wrap-box">
          <div class="tips">
            <div class="t1">抱歉哦～</div>
            <div class="t2">福利为动感地带芒果卡用户专享权益</div>
          </div>
          <div class="ft">
            <div class="confirm" @click="handleConfirm">
              去办理动感地带芒果卡包
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup as VanPopup } from "vant";
import { jumpPage } from "@utils/url";

export default {
  name: "VPopJump",

  components: {
    VanPopup,
  },

  props: {
    popJumpInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      // 展示弹窗
      showPopup: false,
    };
  },

  methods: {
    // 显示弹窗
    open() {
      this.showPopup = true;
    },
    // 关闭弹窗
    close() {
      this.showPopup = false;
    },

    // 跳转
    handleConfirm() {
      jumpPage(this.popJumpInfo.url);
    },
  },
};
</script>

<style lang="less" scoped>
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  权利弹窗
.v-pop-jump {
  position: relative;
  width: 282px;
  .pop-title {
    padding: 10px 16px;
    text-align: center;
    font-weight: 500;
    font-size: 21px;
    color: #001a33;
    font-family: Arial, Helvetica, sans-serif;
    font-style: normal;
  }
  .content {
    position: relative;
    width: 282px;
    margin: 0 auto;
    // min-height: 210px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #474747;
    text-align: center;
    background: #fff;
    border-radius: 26px;
    background-image: url("../assets/image/bg-pop-gift01.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center top;

    .btn-close {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 22px;
      height: 22px;
      background-image: url("../assets/image/icon-pop-close.png");
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center top;
    }
    .wrap-box {
      width: 100%;
      padding: 50px 0 30px 0;
      .tips {
        margin-bottom: 30px;
        padding: 0 20px;
        .t1 {
          margin-bottom: 15px;
          font-weight: 500;
          font-size: 16px;
          color: #001a33;
        }
        .t2 {
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 26, 51, 0.6);
        }
      }
    }
    .ft {
      width: 100%;
      .confirm {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 240px;
        height: 45px;
        margin: 0 auto 5px;
        font-weight: 500;
        font-size: 16px;
        color: #001a33;
        background-image: url("../assets/image/icon-gift-btn.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
        box-sizing: border-box;
      }
    }
  }
}
</style>
